function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.273 24.227l23.547-5.532M27.603 30.248l15.255-3.537M21.198 36.154l11.855-2.748M52.069 56.994l-3.015-11.079 9.33-2.534M34.588 35.47l15.249-3.665M35.953 42.39l11.923-2.72M25.062 51.948c6.075-.009 10.993-4.94 10.985-11.015-.008-6.076-4.94-10.994-11.015-10.985-6.075.008-10.993 4.94-10.985 11.015.008 6.075 4.94 10.993 11.015 10.985zM11.304 46.968a15.053 15.053 0 01-.714-2.005M10.047 40.968a14.956 14.956 0 014.552-10.783",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.489 51.934l2.588 11.117 24.992-6.057 6.314-13.613L50 6.944 15.882 14.96l3.813 16.374M24.222 41.136l11.612-2.352M23.43 47.18l11.959-2.476M17.219 48.676L9.39 60.89a2 2 0 103.369 2.156l7.742-12.078",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M55.504 9.906L59.528 27.4M61.036 32.898l1.006 4.5",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/detail.svg";
export { SvgDetail as ReactComponent };